/**
 * gift-box-limit.js
 *
 * Enforces: gift box quantity in cart can never exceed the quantity
 * of normal (fabric) products in the cart. Shows a warning popup
 * and auto-trims excess gift boxes whenever the cart changes.
 *
 * Pure vanilla JS — no Liquid dependency.
 */
document.addEventListener('DOMContentLoaded', function () {
  const giftBoxProductIds = [
    8860865790149,
    8860865396933,
    8860864807109,
    8860864577733,
    8860830630085,
    8838461620421,
    8838460801221,
    8838458835141,
    8838446776517
  ];

  const giftBoxMessage = 'Important: Gift boxes are available only with fabric purchases. One gift box may be added for each fabric article purchased.';

  let giftBoxFixRunning = false;
  let giftBoxAddRunning = false;
  let lastPopupTime = 0;

  function isGiftBoxItem(item) {
    return giftBoxProductIds.includes(Number(item.product_id));
  }

  function getNormalQty(cart) {
    return cart.items
      .filter(item => !isGiftBoxItem(item))
      .reduce((total, item) => total + item.quantity, 0);
  }

  function getGiftBoxQty(cart) {
    return cart.items
      .filter(item => isGiftBoxItem(item))
      .reduce((total, item) => total + item.quantity, 0);
  }

  async function getCart() {
    const response = await fetch('/cart.js', {
      headers: {
        'Accept': 'application/json'
      }
    });

    return await response.json();
  }

  async function updateCart(updates) {
    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ updates })
    });

    return await response.json();
  }

  function showGiftBoxPopup() {
    const now = Date.now();

    if (now - lastPopupTime < 1200) return;
    lastPopupTime = now;

    const oldPopup = document.querySelector('.gift-box-warning-popup');
    if (oldPopup) oldPopup.remove();

    const popup = document.createElement('div');
    popup.className = 'gift-box-warning-popup';
    popup.innerHTML = `
      <div class="gift-box-warning-popup__box">
        <button type="button" class="gift-box-warning-popup__close" aria-label="Close">×</button>

        <div class="gift-box-warning-popup__icon">
          <span>!</span>
        </div>

        <h3>Gift Box Limit</h3>

        <p>${giftBoxMessage}</p>

        <button type="button" class="gift-box-warning-popup__ok">
          Got it
        </button>
      </div>
    `;

    document.body.appendChild(popup);

    requestAnimationFrame(function () {
      popup.classList.add('is-visible');
    });

    function closePopup() {
      popup.classList.remove('is-visible');
      popup.classList.add('is-closing');

      setTimeout(function () {
        if (popup && popup.parentNode) {
          popup.remove();
        }
      }, 300);
    }

    popup.querySelector('.gift-box-warning-popup__close').addEventListener('click', closePopup);
    popup.querySelector('.gift-box-warning-popup__ok').addEventListener('click', closePopup);

    popup.addEventListener('click', function (e) {
      if (e.target === popup) {
        closePopup();
      }
    });

    setTimeout(function () {
      if (popup && popup.parentNode) {
        closePopup();
      }
    }, 6000);
  }

  function addGiftBoxPopupCSS() {
    if (document.querySelector('#gift-box-warning-popup-css')) return;

    const style = document.createElement('style');
    style.id = 'gift-box-warning-popup-css';
    style.innerHTML = `
      .gift-box-warning-popup {
        position: fixed;
        inset: 0;
        z-index: 999999;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(18, 18, 18, 0);
        backdrop-filter: blur(0px);
        -webkit-backdrop-filter: blur(0px);
        padding: 20px;
        opacity: 0;
        pointer-events: none;
        transition:
          opacity 0.3s ease,
          background 0.3s ease,
          backdrop-filter 0.3s ease,
          -webkit-backdrop-filter 0.3s ease;
      }

      .gift-box-warning-popup.is-visible {
        opacity: 1;
        pointer-events: auto;
        background: rgba(18, 18, 18, 0.45);
        backdrop-filter: blur(6px);
        -webkit-backdrop-filter: blur(6px);
      }

      .gift-box-warning-popup.is-closing {
        opacity: 0;
        pointer-events: none;
        background: rgba(18, 18, 18, 0);
        backdrop-filter: blur(0px);
        -webkit-backdrop-filter: blur(0px);
      }

      .gift-box-warning-popup__box {
        position: relative;
        max-width: 430px;
        width: 100%;
        background: #ffffff;
        color: #111111;
        padding: 38px 30px 30px;
        text-align: center;
        box-shadow: 0 24px 70px rgba(0, 0, 0, 0.22);
        transform: translateY(28px) scale(0.94);
        opacity: 0;
        transition:
          transform 0.38s cubic-bezier(0.22, 1, 0.36, 1),
          opacity 0.3s ease;
        border-radius: 0;
        overflow: hidden;
      }

      .gift-box-warning-popup.is-visible .gift-box-warning-popup__box {
        transform: translateY(0) scale(1);
        opacity: 1;
      }

      .gift-box-warning-popup.is-closing .gift-box-warning-popup__box {
        transform: translateY(18px) scale(0.96);
        opacity: 0;
      }

      .gift-box-warning-popup__box::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 4px;
        background: linear-gradient(90deg, #111111, #8a6a3f, #111111);
        background-size: 200% 100%;
        animation: giftBoxShimmer 2.2s linear infinite;
      }

      .gift-box-warning-popup__icon {
        width: 58px;
        height: 58px;
        margin: 0 auto 18px;
        border-radius: 50%;
        background: #111111;
        color: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 30px;
        font-weight: 600;
        box-shadow: 0 12px 28px rgba(0, 0, 0, 0.18);
        animation: giftBoxPulse 1.8s ease-in-out infinite;
      }

      .gift-box-warning-popup__icon span {
        transform: translateY(-1px);
      }

      .gift-box-warning-popup__box h3 {
        margin: 0 0 12px;
        font-size: 24px;
        line-height: 1.2;
        font-weight: 600;
        letter-spacing: 0.02em;
        color: #111111;
      }

      .gift-box-warning-popup__box p {
        margin: 0 auto 24px;
        max-width: 340px;
        font-size: 15px;
        line-height: 1.65;
        color: #333333;
      }

      .gift-box-warning-popup__ok {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        min-width: 130px;
        min-height: 46px;
        padding: 12px 24px;
        border: 1px solid #111111;
        background: #111111;
        color: #ffffff;
        font-size: 14px;
        font-weight: 600;
        letter-spacing: 0.04em;
        text-transform: uppercase;
        cursor: pointer;
        transition:
          background 0.25s ease,
          color 0.25s ease,
          transform 0.25s ease;
      }

      .gift-box-warning-popup__ok:hover {
        background: #ffffff;
        color: #111111;
        transform: translateY(-2px);
      }

      .gift-box-warning-popup__close {
        position: absolute;
        top: 12px;
        right: 16px;
        border: 0;
        background: transparent;
        font-size: 28px;
        line-height: 1;
        cursor: pointer;
        color: #111111;
        opacity: 0.65;
        transition: opacity 0.2s ease, transform 0.2s ease;
        z-index: 2;
      }

      .gift-box-warning-popup__close:hover {
        opacity: 1;
        transform: rotate(90deg);
      }

      @keyframes giftBoxPulse {
        0%, 100% {
          transform: scale(1);
          box-shadow: 0 12px 28px rgba(0, 0, 0, 0.18);
        }

        50% {
          transform: scale(1.06);
          box-shadow: 0 16px 36px rgba(0, 0, 0, 0.24);
        }
      }

      @keyframes giftBoxShimmer {
        0% {
          background-position: 0% 50%;
        }

        100% {
          background-position: 200% 50%;
        }
      }

      @media screen and (max-width: 480px) {
        .gift-box-warning-popup__box {
          padding: 34px 22px 26px;
        }

        .gift-box-warning-popup__box h3 {
          font-size: 21px;
        }

        .gift-box-warning-popup__box p {
          font-size: 14px;
        }
      }
    `;

    document.head.appendChild(style);
  }

  function refreshCartUI() {
    document.dispatchEvent(new CustomEvent('cart:build'));
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
    document.dispatchEvent(new CustomEvent('cart:updated'));

    if (window.theme && window.theme.cart && typeof window.theme.cart.getCart === 'function') {
      window.theme.cart.getCart();
    }
  }

  async function enforceGiftBoxLimit() {
    if (giftBoxFixRunning) return;

    giftBoxFixRunning = true;

    try {
      const cart = await getCart();

      const normalQty = getNormalQty(cart);
      const giftBoxQty = getGiftBoxQty(cart);

      if (giftBoxQty <= normalQty) {
        giftBoxFixRunning = false;
        return;
      }

      showGiftBoxPopup();

      let extraQty = giftBoxQty - normalQty;
      const updates = {};

      const giftBoxItems = cart.items.filter(item => isGiftBoxItem(item));

      for (const item of giftBoxItems) {
        if (extraQty <= 0) break;

        if (item.quantity <= extraQty) {
          updates[item.key] = 0;
          extraQty -= item.quantity;
        } else {
          updates[item.key] = item.quantity - extraQty;
          extraQty = 0;
        }
      }

      await updateCart(updates);
      refreshCartUI();

    } catch (error) {
      console.error('Gift box limit error:', error);
    }

    giftBoxFixRunning = false;
  }

  document.addEventListener('submit', async function (e) {
    const form = e.target.closest('.gift-addon__form');
    if (!form) return;

    e.preventDefault();

    if (giftBoxAddRunning) return;
    giftBoxAddRunning = true;

    const button = form.querySelector('[type="submit"], button[name="add"]');
    const oldButtonText = button ? button.textContent : '';

    if (button) {
      button.disabled = true;
      button.textContent = 'Adding...';
    }

    try {
      const cart = await getCart();

      const normalQty = getNormalQty(cart);
      const giftBoxQty = getGiftBoxQty(cart);

      const quantityInput = form.querySelector('[name="quantity"]');
      const addingQty = quantityInput ? Number(quantityInput.value || 1) : 1;

      if (normalQty === 0) {
        showGiftBoxPopup();
        return;
      }

      if (giftBoxQty + addingQty > normalQty) {
        showGiftBoxPopup();
        return;
      }

      const formData = new FormData(form);

      const addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'application/json'
        }
      });

      if (!addResponse.ok) {
        throw new Error('Gift box add failed');
      }

      refreshCartUI();

    } catch (error) {
      console.error('Gift box add validation error:', error);
      alert('Something went wrong. Please try again.');
    } finally {
      giftBoxAddRunning = false;

      if (button) {
        button.disabled = false;
        button.textContent = oldButtonText || 'Add to cart';
      }
    }
  });

  const originalFetch = window.fetch;

  window.fetch = async function () {
    const response = await originalFetch.apply(this, arguments);

    try {
      const url = typeof arguments[0] === 'string'
        ? arguments[0]
        : arguments[0].url;

      if (
        url &&
        (
          url.includes('/cart/change') ||
          url.includes('/cart/update') ||
          url.includes('/cart/add') ||
          url.includes('/cart/clear')
        )
      ) {
        setTimeout(enforceGiftBoxLimit, 500);
      }
    } catch (error) {}

    return response;
  };

  const originalXHROpen = XMLHttpRequest.prototype.open;
  const originalXHRSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url) {
    this._giftBoxCartUrl = url;
    return originalXHROpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function () {
    this.addEventListener('load', function () {
      if (
        this._giftBoxCartUrl &&
        (
          this._giftBoxCartUrl.includes('/cart/change') ||
          this._giftBoxCartUrl.includes('/cart/update') ||
          this._giftBoxCartUrl.includes('/cart/add') ||
          this._giftBoxCartUrl.includes('/cart/clear')
        )
      ) {
        setTimeout(enforceGiftBoxLimit, 500);
      }
    });

    return originalXHRSend.apply(this, arguments);
  };

  document.addEventListener('click', function (e) {
    if (
      e.target.closest('button') ||
      e.target.closest('a') ||
      e.target.closest('[data-cart-remove]') ||
      e.target.closest('[data-cart-item-remove]') ||
      e.target.closest('[data-quantity-button]')
    ) {
      setTimeout(enforceGiftBoxLimit, 800);
    }
  });

  document.addEventListener('change', function (e) {
    if (
      e.target.matches('input[name="updates[]"]') ||
      e.target.matches('input[name="quantity"]') ||
      e.target.closest('form[action="/cart"]')
    ) {
      setTimeout(enforceGiftBoxLimit, 800);
    }
  });

  addGiftBoxPopupCSS();
  enforceGiftBoxLimit();
});